<div class="card" [ngClass]="{ 'card--link': link }" [ngStyle]="{ 'width.px': width }" app-ripple [ripple-disabled]="!link">
  @if (link) {
    <span class="card__link" app-slider-link>
      <a class="card__link-inner" [routerLink]="link" [fragment]="fragment" (click)="click()">
        @if (title) {
          <span class="card__link-text">{{ title }}</span>
        }
      </a>
    </span>
  }
  <div class="card__content">
    <ng-content></ng-content>
  </div>
</div>
